import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const CalendarComponent = ({ visible, onClose, onDateSelect, initialDate }) => {
  const [currentDate, setCurrentDate] = useState(initialDate || new Date());

  const getCalendarDays = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const today = new Date();
    const isCurrentMonthAndYear =
      today.getMonth() === month && today.getFullYear() === year;
  
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const prevMonthDays = new Date(year, month, 0).getDate();
  
    const days = [];
  
    // Previous month's trailing days
    for (let i = 0; i < firstDay; i++) {
      days.push({
        day: prevMonthDays - firstDay + i + 1,
        disabled: true,
        isCurrentMonth: false,
        isPrevMonth: true,
      });
    }
  
    // Current month days
    for (let i = 1; i <= daysInMonth; i++) {
      const isFuture =
        isCurrentMonthAndYear && i > today.getDate() ||
        year > today.getFullYear() ||
        (year === today.getFullYear() && month > today.getMonth());
  
      days.push({
        day: i,
        disabled: isFuture,
        isCurrentMonth: true,
        isPrevMonth: false,
      });
    }
  
    // Next month's leading days
    const remainingCells = 42 - days.length;
    for (let i = 1; i <= remainingCells; i++) {
      days.push({
        day: i,
        disabled: true,
        isCurrentMonth: false,
        isPrevMonth: false,
      });
    }
  
    return days;
  };
  

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const calendarDays = getCalendarDays(currentDate);

  const prevMonth = () => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() - 1);
    setCurrentDate(newDate);
  };

  const nextMonth = () => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() + 1);
    setCurrentDate(newDate);
  };

  const selectDate = (day) => {
    if (!day.disabled) {
      const newDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        day.day
      );
      onDateSelect(newDate);
      onClose();
    }
  };

  const renderDay = (item, index) => {
    const isToday =
      item.isCurrentMonth &&
      new Date().getDate() === item.day &&
      new Date().getMonth() === currentDate.getMonth() &&
      new Date().getFullYear() === currentDate.getFullYear();

    return (
      <div
        key={index}
        onClick={() => selectDate(item)}
        className={`d-flex justify-content-center align-items-center m-1 rounded ${
          item.disabled ? "opacity-50 text-muted" : "text-dark"
        } ${
          isToday ? "bg-light border border-primary fw-bold text-primary" : ""
        }`}
        style={{
          width: "8vw", // responsive width
          minWidth: "30px",
          maxWidth: "59px",
          height: "30px",
          cursor: item.disabled ? "default" : "pointer",
        }}
      >
        {item.day}
      </div>
    );
  };

  return (
    <Modal
      show={visible}
      onHide={onClose}
      centered
      backdrop="true"
      dialogClassName="calendar-modal"
    >
      <div className="position-relative">
        <button
          onClick={onClose}
          className="btn-light position-absolute end-0 mt-2 me-3 rounded-circle"
          style={{ zIndex: 10, width: "30px", height: "30px", lineHeight: "0" }}
          aria-label="Close calendar"
        >
          ✕
        </button>
        <div className="bg-white p-4 rounded-4 mx-3">
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
            <button
              className="btn btn-link text-secondary fs-1 p-0"
              onClick={prevMonth}
              aria-label="Previous month"
            >
              ‹
            </button>
            <div className="d-flex align-items-center gap-3 flex-grow-1 justify-content-center flex-wrap">
              <span className="fw-medium fs-5 text-dark">
                {currentDate.toLocaleString("default", { month: "long" })}
              </span>
              <span className="fw-medium fs-5 text-dark">
                {currentDate.getFullYear()}
              </span>
            </div>
            <button
              className="btn btn-link text-secondary fs-1 p-0"
              onClick={nextMonth}
              aria-label="Next month"
            >
              ›
            </button>
          </div>

          <div className="d-flex justify-content-between mb-2">
            {daysOfWeek.map((day, index) => (
              <div
                key={index}
                className="flex-fill text-center text-muted fw-medium small"
              >
                {day}
              </div>
            ))}
          </div>

          <div
            className="d-flex flex-wrap justify-content-start"
            style={{ maxWidth: "100%" }}
          >
            {calendarDays.map((item, index) => renderDay(item, index))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CalendarComponent;
